// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CreateAwsCertificate_closeButton__10LAB"};